export const SET_PAGES = 'SET_PAGES';

